import { Component, OnInit, Output, Input, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Options } from 'ngx-slider-v2';
import { Console } from 'console';
import { ActivatedRoute, Router } from '@angular/router'
import { MyService } from 'src/app/shared/services/myservice';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit {

  // Using Output EventEmitter
  @Output() priceFilter: EventEmitter<any> = new EventEmitter<any>();

  // define min, max and range
  @Input() min: number = 0;
  @Input() max: number = 2000;
  // minValue1: number = 0;
  // maxValue1: number = 2000;

  @Input() minDummy: number = 0;
  @Input() maxDummy: number = 2000;

  public collapse: boolean = true;
  public isBrowser: boolean = false;

  public price: any;

  options: Options = {
    floor: 0,
    ceil: 2000

  };

  // minDummy1: number = 0;
  // maxDummy1: number = 2000;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, private myService: MyService, private route: ActivatedRoute,) {
    if (isPlatformBrowser(this.platformId)) {
      // console.log(this.platformId)
      this.isBrowser = true; // for ssr
      // if (this.isBrowser == true) {
      //   if (this.min === 0) {
      //     this.min = 0
      //     console.log('11111111111111111')
      //   }
      //   if (this.max === 2000) {
      //     this.maxDummy = this.max
      //     console.log('2222222222222222')

      //   }
      // }


      // if (this.router.url === '/shop/collection/left/sidebar?minPrice=0&maxPrice=2000') {
      //   console.log(this.router.url)

      //   let min = this.min
      //   let max = this.max
      //   console.log(min)
      //   console.log(max)

      //   if (min === 0) {
      //     this.minValue1 = 0
      //     console.log('11111111111111111')
      //   }
      //   if (max === 2000) {
      //     this.maxValue1 = 2000
      //     console.log('2222222222222222')

      //   }
      // }
    }

  }
  ngOnInit(): void {
    this.min = 0;
    this.max = 2000;
    // Listen to query parameters
    this.route.queryParams.subscribe(params => {
      // Parse the values and set them to the slider
      this.min = params.minPrice ? +params.minPrice : this.min; // Use parsed value or default
      this.max = params.maxPrice ? +params.maxPrice : this.max; // Use parsed value or default
    });
  }

  formatNumber(event: any) {
    this.min = event.target.value.replace(/^0+/, '') || '0'; // Removes leading zeros
  }
  

  // Range Changed
  appliedFilter(event: any) {
    // console.log(event);
    this.minDummy = this.min
    this.maxDummy = this.max
    this.price = { minPrice: event.value || this.minDummy, maxPrice: event.highValue || this.maxDummy };
    // console.log(this.price);
    this.priceFilter.emit(this.price);
  }

  changeprice(event: any) {
    // Check if the name attribute is for min or max value
    // if (event.target.name === "minValue1") {
    //   this.min = event.target.value ? parseInt(event.target.value, 10) : 0;
    //   this.appliedFilter(event);
    // } else if (event.target.name === "maxValue1") {
    //   this.max = event.target.value ? parseInt(event.target.value, 10) : 0;
    this.appliedFilter(event);
    // }
  }

  // changeprice(event: any) {
  //   // Validate min and max values
  //   if (this.min > this.max) {
  //     // Swap values if min exceeds max
  //     const temp = this.min;
  //     this.min = this.max;
  //     this.max = temp;
  //   }

  //   // Trigger appliedFilter with updated values
  //   setTimeout(() => {
  //     this.appliedFilter(event);
  //   }, 2000);
  // }


  removeItem(event) {
    // this.minValue1 = 0
    // this.maxValue1 = 2000
    this.min = 0
    this.max = 2000
    this.appliedFilter(event)
  }
}
